module.exports = __webpack_public_path__ + "static/media/r26.d30f9653.jpg";